module.exports = __webpack_public_path__ + "img/happyhr.77db5049.jpeg";